import {
  Modal,
  Paper,
  useMediaQuery,
  useTheme,
  Avatar,
  IconButton,
  Box,
} from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleClose } from 'Images';

interface ICustomDialog {
  showDialog: boolean;
  onclose: () => void;
  children: React.ReactNode;
  width?: string;
  height?: string;
  mt?: string;
  isScroll?: boolean;
  top?: string;
}

export const CustomDialog = ({
  onclose,
  showDialog,
  children,
  width,
  height,
  mt,
  isScroll,
  top,
}: ICustomDialog) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Modal
      open={showDialog}
      onClose={onclose}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(8, 30, 84, .8)',
          height: '100vh',
        },
      }}
      sx={{
        overflowY: isScroll ? 'auto' : undefined,
        zIndex: isDesktop ? 9999 : undefined,
      }}
    >
      <>
        <Paper
          sx={{
            position: 'absolute',
            top: top || '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: width || { xs: '350px', sm: '770px' },
            height: height || { xs: '350px', sm: '486px' },
            backgroundColor: 'primary.shade_100',
            borderRadius: '16px',
            mt: mt,
          }}
        >
          <IconButton
            onClick={onclose}
            sx={{
              position: 'absolute',
              top: isDesktop ? '24px' : '15px',
              right: isDesktop ? '19px' : '15px',
            }}
          >
            <Avatar
              src={PurpleClose}
              alt={
                Dictionary[DICTIONARY.Requests].deleteFile.deleteModalExitAlt
              }
            />
          </IconButton>
          {children}
        </Paper>
        {isScroll && <Box height='160vh' width='200px' />}
      </>
    </Modal>
  );
};
